// 2026-10-13：超级管理员提问使用独立队列接口，仅提交问题并读取GPT文字回复。
import request from '@/utils/request'

export interface GptQuestion {
  id: string
  text: string
  answer: string
  status: 'pending' | 'answering' | 'completed' | 'failed'
  createdAt: number
  updatedAt: number
}

export interface GptQuestionsSnapshot {
  messages: GptQuestion[]
  online: boolean
  retentionDays: number
}

// 2026-10-13：兼容Jackson省略空列表，仅完整有效的队列状态可补空messages，错误响应仍拒绝。
const snapshot = (response: { data?: unknown; success?: boolean }): GptQuestionsSnapshot => {
  const data = response?.data
  if (!data || typeof data !== 'object' || Array.isArray(data) || response?.success === false) {
    throw new Error('提问记录返回异常，请重试。')
  }
  const value = data as Partial<GptQuestionsSnapshot>
  const hasMessages = Object.prototype.hasOwnProperty.call(value, 'messages')
  if (typeof value.online !== 'boolean' || typeof value.retentionDays !== 'number'
    || !Number.isInteger(value.retentionDays) || value.retentionDays < 1 || value.retentionDays > 90
    || (hasMessages && !Array.isArray(value.messages))) {
    throw new Error('提问记录返回异常，请重试。')
  }
  return hasMessages ? value as GptQuestionsSnapshot : { ...value, online: value.online, retentionDays: value.retentionDays, messages: [] }
}

export default {
  list: (signal?: AbortSignal) => request({ url: 'system/gptQuestions', method: 'GET', signal }).then(snapshot),
  ask: (text: string, requestId: string, signal?: AbortSignal) =>
    request({ url: 'system/gptQuestions', method: 'POST', data: { text, requestId }, signal }).then(snapshot)
}
